// extracted by mini-css-extract-plugin
export default {"link":"aa0BzVXDUs"};
    if(module.hot) {
      // 1643570424006
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  